import React from 'react'
import PropTypes from 'prop-types'

import Dropdown from 'Components/Dropdown'

import { _PanelDropdown, _Title } from './styles'

const PanelDropdownV2 = (
  {
    label,
    children,
    dropdownContentSide = 'right',
    useGrid = false,
    closeOnSelect = true,
    gaFromComponent,
    gaFromPage,
    onResetBtnClick,
    additionalBtns,
  }) =>
  (
    <_PanelDropdown
      dropdownContentSide={dropdownContentSide}
      gridStyle={useGrid}
    >
      <Dropdown
        title={<_Title>{label}</_Title>}
        blurBackground={false}
        closeOnSelect={closeOnSelect}
        gaFromComponent={gaFromComponent}
        gaFromPage={gaFromPage}
        onResetBtnClick={onResetBtnClick}
        additionalBtns={additionalBtns}
      >
        {children}
      </Dropdown>
    </_PanelDropdown>
  )

PanelDropdownV2.propTypes = {
  label: PropTypes.string,
  metaData: PropTypes.shape({
    valueLabelLookup: PropTypes.shape({}),
  }),
  children: PropTypes.node,
  dropdownContentSide: PropTypes.string,
  useGrid: PropTypes.bool,
  closeOnSelect: PropTypes.bool,
  gaFromComponent: PropTypes.string,
  gaFromPage: PropTypes.string,
  additionalBtns: PropTypes.bool,
  onResetBtnClick: PropTypes.func,
}

export default PanelDropdownV2
